export enum Role {
  SuperUser = 'SUPER_USER',
  SupportAdmin = 'SUPPORT_ADMIN',
  MasterOfRoles = 'MASTER_OF_ROLES',
  DataAdministrator = 'DATA_ADMINISTRATOR',
  NewsletterAdministrator = 'NEWSLETTER_ADMINISTRATOR',
  DeliveryNoteManager = 'DELIVERY_NOTE_MANAGER',
  OutboundTransportPlanner = 'OUTBOUND_TRANSPORT_PLANNER',
  CanaryTransportPlanner = 'CANARY_TRANSPORT_PLANNER',
  CanaryLatamTransportPlanner = 'CANARY_LATAM_TRANSPORT_PLANNER',
  GoodsIssueManager = 'GOODS_ISSUE_MANAGER',
  GoodsReceiptManager = 'GOODS_RECEIPT_MANAGER',
  QualityManager = 'QUALITY_MANAGER',
  DataQualityManager = 'DATA_QUALITY_MANAGER',
  BackofficeManager = 'BACKOFFICE_MANAGER',
  TransportPlanner = 'TRANSPORT_PLANNER',
  HubAdministrator = 'HUB_ADMINISTRATOR',
  DockSupervisor = 'DOCK_SUPERVISOR',
  YardSupervisor = 'YARD_SUPERVISOR',
  YardMainGateWorker = 'YARD_MAIN_GATE_WORKER',
  YardSecurityWorker = 'YARD_SECURITY_WORKER',
  DockWorker = 'DOCK_WORKER',
  DockWatcher = 'DOCK_WATCHER',
  GoodsReceiptWorker = 'GOODS_RECEIPT_WORKER',
  AdminUser = 'ADMIN_USER',
  CarrierBackofficeManager = 'CARRIER_BACKOFFICE_MANAGER',
  PartnerAdministrator = 'PARTNER_ADMINISTRATOR',
  CarrierSupportAdmin = 'CARRIER_SUPPORT_ADMIN',
  ComplianceOfficer = 'COMPLIANCE_OFFICER',
  NfSupervisor = 'NF_SUPERVISOR',
}

export enum RolesViewType {
  ChipView = 'CHIP_VIEW',
  TableView = 'TABLE_VIEW',
}
